import { render, staticRenderFns } from "./BetaPluginDialog.vue?vue&type=template&id=f85c77d0&scoped=true"
import script from "./BetaPluginDialog.vue?vue&type=script&lang=ts"
export * from "./BetaPluginDialog.vue?vue&type=script&lang=ts"
import style0 from "./BetaPluginDialog.vue?vue&type=style&index=0&id=f85c77d0&prod&lang=scss"
import style1 from "./BetaPluginDialog.vue?vue&type=style&index=1&id=f85c77d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85c77d0",
  null
  
)

export default component.exports